// extracted by extract-css-chunks-webpack-plugin
module.exports = {"saveButton":"IPm3S1"};